import React from "react";
import "./ConfigPane.scss";
import "../JSONHTML.css";
import Tabs from "../Tabs";

import DeviceComConfigPane from "./DeviceComConfigPane";
import DeviceDataConfigPane from "./DeviceDataConfigPane";
import DeviceSensorConfigPane from "./DeviceSensorDataConfigPane";

import { resolvedSensorConfigSelector } from "../../../../selectors";

import { Icon } from "react-icons-kit";
import { check, plus } from "react-icons-kit/feather/";

import PalamButton from "../../../generic/palam_button";

import { withTranslation } from 'react-i18next';


class DeviceConfigWindow extends React.Component {
  // TODO: rename idx to key
  renderSensorConfigPanes() {
    let {
      device,
      //setDeviceDataValue,
      setDeviceSensorDataValue,
      requestSetDeviceSensorDataValue,
      requestDeleteSensor,
      requestResetJSONState
    } = this.props;
    return Object.keys(device.sensorConfig).map((sensor, idx) => {
      let sensorName = "";

      let mergedSensorConfig = resolvedSensorConfigSelector(device, sensor);
       
      if (
        mergedSensorConfig &&
        mergedSensorConfig.hasOwnProperty("name") &&
        mergedSensorConfig.name &&
        mergedSensorConfig.name.hasOwnProperty("value") &&
        mergedSensorConfig.name.value
      ) {
        sensorName = mergedSensorConfig.name.value;
      }

      let key = Object.keys(device.sensorConfig)[idx];

      return (
        <div
          alias={sensorName}
          label={"Sensor " + (idx + 1)}
          key={key}
          sensorKey={key}
        >
          <DeviceSensorConfigPane
            device={device}
            sensorIdx={key}
            requestResetJSONState={requestResetJSONState}
            setDeviceSensorDataValue={setDeviceSensorDataValue}
            requestSetDeviceSensorDataValue={requestSetDeviceSensorDataValue}
            requestDeleteSensor={requestDeleteSensor}
          />
        </div>
      );
    });
  }

  render() {
    let {
      //uid,
      device,
      setDeviceDataValue,
      //setDeviceSensorDataValue,
      requestSetDeviceDataValue,
      requestAddSensor,
      requestResetJSONState,
      showSensor,
      requestDeleteDevice,
      hideDeviceSettings,
      requestResetTemplateId,
      requestSaveTemplate,
      requestResetDevice,
      removeFromDeviceTemplateBlacklist,
      requestActivateTemplate,
      setDetectedQuerx,
      resetDetectedQuerx,
      t
    } = this.props;

    let deviceName = device.uid;
    if (
      device.hasOwnProperty("resolvedDataConfig") &&
      device.resolvedDataConfig.hasOwnProperty("name")
    ) {
      deviceName = device.resolvedDataConfig.name;
    }
    return (
      <div className="configpane">
        <div className="configpane-head">
          <div className="l">
            <PalamButton
              extraClasses="full"
              onClick={() => {
                requestAddSensor(device.uid);
              }}
            >
              <Icon size={24} icon={plus} /> Sensor
            </PalamButton>
          </div>
          <div className="m">{t("device_config_label")} {deviceName} ({device.uid})</div>
          <div className="r" />
        </div>
        <Tabs showSensor={showSensor}>
          <div label={t("device_settings_label")}>
            <DeviceDataConfigPane
              device={device}
              requestResetJSONState={requestResetJSONState}
              setDeviceDataValue={setDeviceDataValue}
              requestSetDeviceDataValue={requestSetDeviceDataValue}
              requestDeleteDevice={requestDeleteDevice}
              requestResetTemplateId={requestResetTemplateId}
              requestSaveTemplate={requestSaveTemplate}
              requestResetDevice={requestResetDevice}
              removeFromDeviceTemplateBlacklist={
                removeFromDeviceTemplateBlacklist
              }
              requestActivateTemplate={requestActivateTemplate}
              setDetectedQuerx={setDetectedQuerx}
              resetDetectedQuerx={resetDetectedQuerx}
            />
          </div>
          <div label={t("apikey_label")}>
            <DeviceComConfigPane device={device} />
          </div>
          {this.renderSensorConfigPanes()}

          {/*           <div
            label="Add Sensor"
            buttonAction={() => {
              requestAddSensor(device.uid);
            }}
          /> */}
        </Tabs>
        <div className="configpane-foot">
          <div className="configpane-hide-button" onClick={hideDeviceSettings}>
            <Icon size={36} icon={check} />
          </div>
        </div>
      </div>
    );
  }
}

export default withTranslation()(DeviceConfigWindow);
